import React, { useContext } from 'react'
import Slide from '../ui/Slide'
import { AppContext } from '../../context'
import { Spinner } from 'react-bootstrap'

const BookmarkPopover: React.FC = () => {
  const {
    activePopover,
    onTogglePopover,
    bookmarks,
    handleBookmarks,
    bookmarksLoading,
    setLocationToView
  } = useContext(AppContext)
  const isVisible = activePopover === 'bookmark'

  if (!bookmarks) return null

  return (
    <Slide
      isVisible={isVisible}
      id="bookmarks-overlay"
      className="overlay overlay-right hidden"
    >
      <div id="close" className="card-header">
        <a
          className="close-button btn-pill no-fill no-label"
          onClick={() => onTogglePopover('')}
        >
          <span className="material-icons">clear</span>
        </a>
      </div>
      <div className="panel-body">
        <div className="card-body">
          <h2>Bookmarks</h2>
          {!bookmarks.length ? (
            <div id="bookmarks-empty">
              <h3 id="bookmarksempty-title">Your bookmarks are empty</h3>
              <p id="bookmarksempty-sub-title">
                You can save locations and Almanac data to your bookmark list to
                use later by tapping the bookmark icon in the information
                pop-ups.
              </p>
            </div>
          ) : (
            <div id="bookmarks-list">
              {bookmarks.map(bookmark => (
                <div className="bookmarks-item" key={bookmark?.id}>
                  <div className="bookmark-body">
                    <h4 className="bookmark-title">{bookmark?.name}</h4>
                    {/*       <span className="bookmark-subtitle">
                      {bookmark.category}
                    </span>*/}
                  </div>
                  <div className="bookmark-footer">
                    <div>
                      <a
                        className="btn-primary-textlink bookmark-view"
                        onClick={() =>
                          setLocationToView({
                            id: bookmark?.content_id ?? '',
                            layer: 'places' as const
                          })
                        }
                      >
                        VIEW
                      </a>
                      <a
                        className="btn-secondary-textlink bookmark-remove"
                        onClick={() => handleBookmarks('remove', bookmark)}
                      >
                        REMOVE
                      </a>
                    </div>
                    {bookmarksLoading && (
                      <Spinner animation="border" size="sm" variant="primary" />
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {/*      <div className="card-footer">
        <a
          className="btn btn-secondary"
          onClick={() => handleBookmarks('remove-all')}
        >
          Remove All
        </a>
      </div>*/}
    </Slide>
  )
}

export default BookmarkPopover
